import { GitError } from '../wasm-git-worker-errors.model';
import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitShowAction extends WorkerAction {
  type: GitAction.Show;
  params: { branch: string; path?: string };
}

export class GitShowActionError extends WorkerActionError {}

export async function GitShowActionFn({ lg, params }: WorkerFnParams<GitShowAction>): Promise<string> {
  const { branch, path } = params;

  try {
    const sha1 = lg.callAndCaptureOutput(['rev-parse', [branch, path].filter(Boolean).join(':')]);
    // important: need to trim() because return value may contain new-line character
    return lg.callAndCaptureOutput(['cat-file', '-p', sha1.trim()]);
  } catch (err) {
    const msg = (err as GitError).message || '';
    if (`${msg}`.includes('does not exist in the given tree')) {
      // the file is *most probably* new and simply doesn't yet exist on the compared branch
      console.debug(err);
      return '';
    } else {
      throw new GitShowActionError(err);
    }
  }
}
